var _style, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelocateFrom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n\t\t\tfill: #327DFF;\n\t\t}\n\n\t\t.st1 {\n\t\t\tfill: #FFFFFF;\n\t\t}\n\t")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.8,6.4c0-0.2-0.2-0.4-0.4-0.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3v0.8c0,0.2,0.1,0.4,0.3,0.4l1.7-0.1l0,0L9.8,14 c-0.1,0.1-0.1,0.3,0,0.4l0.5,0.5c0.1,0.1,0.3,0.1,0.4,0l6.5-6.5l0,0l-0.1,1.7c0,0.2,0.2,0.3,0.4,0.3h0.8c0.2,0,0.3-0.1,0.3-0.3 L18.8,6.4z M15.3,11.5L14.7,12c0,0-0.1,0.1-0.1,0.2v4.5c0,0.1-0.1,0.1-0.1,0.1h-8c-0.1,0-0.1,0-0.1-0.1v-8c0-0.1,0-0.1,0.1-0.1h7.1 c0.3,0,0.4-0.3,0.2-0.5l-0.6-0.6c0,0-0.1-0.1-0.2-0.1H6.4C5.7,7.5,5.2,8,5.2,8.6v8.2c0,0.6,0.5,1.1,1.1,1.1h8.2 c0.6,0,1.1-0.5,1.1-1.1v-5.2C15.6,11.5,15.4,11.4,15.3,11.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelocateFrom);
export default __webpack_public_path__ + "static/media/Relocate-From.482229db7d2e6480c335ad68d1faa794.svg";
export { ForwardRef as ReactComponent };